// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__30AdO","fix-aspect-ratio":"style_fix-aspect-ratio__1vEsi","content":"style_content__1pJDG"};